import { h } from 'preact';

import Background from './Background';
import Cloud from './Cloud';
import RakuPack from './RakuPack';
import Train from './Train';
import Trees from './Trees';

import styles from './hotelsLoading.module.scss';

function HotelsLoading() {
  return (
    <svg viewBox="0 0 527 356" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Background />
      <RakuPack />
      <Train className={styles.train} />
      <Trees />
      <Cloud className={styles.cloudLeft} />
      <Cloud className={styles.cloudCenter} />
      <Cloud className={styles.cloudRight} />
    </svg>
  );
}

export default HotelsLoading;
